<template>
  <div class="form-group">
    <label class="color-negative">Foto’s voor deze ruimte toevoegen</label>

    <div class="intake-upload">
      <UploadComponent
        ref="upload"
        v-model="files"
        post-action="/api/room-media-upload"
        @input="input"
        @input-filter="inputFilter"
        :data="{ '_method': 'PUT', '_token': csrfToken }"
        :multiple="true"
        :drop="true"
      >
        <strong>Kies bestanden</strong>
      </UploadComponent>

      <ul class="intake-upload__list">
        <li
          v-for="(mediaItem, mediaItemIndex) in mediaItems"
          :key="mediaItemIndex"
          class="intake-upload__item font-size-xs"
        >
          <img
            v-if="mediaItem.response"
            :src="mediaItem.response"
            width="50"
            height="50"
          />

          {{ mediaItem.name }}

          <div
            class="intake-upload__status"
            :class="'is-' + (mediaItem.success ? 'success' : 'uploading')"
            v-if="mediaItem.success"
          >
            {{ mediaItem.success ? 'Geüpload' : 'Aan het uploaden' }}
          </div>

          <div v-if="mediaItem.error">
            Error: {{ mediaItem.error }}
          </div>

          <button
            v-if="mediaItem.success === true || mediaItem.success === undefined"
            type="button"
            class="intake-upload__remove btn btn--sm btn--icon-only"
            @click="() => removeFileFromRoom([selectedRoom, mediaItemIndex])"
          >
            <Icon name="trash" />
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import UploadComponent from 'vue-upload-component';
import Icon from '@/intake/components/Icon.vue';

export default {
  components: {
    UploadComponent,
    Icon,
  },

  computed: {
    ...mapGetters({
      csrfToken: 'csrfToken',
      selectedRoom: 'room/selectedRoom',
      selectedRoomIndex: 'room/selectedRoomIndex',
    }),

    mediaItems() {
      return this.selectedRoom.media;
    }
  },

  data() {
    return {
      files: [],
      roomIndex: this.selectedRoomIndex,
    };
  },

  updated() {
    if (this.selectedRoomIndex !== this.roomIndex) {
      this.roomIndex = this.selectedRoomIndex;
      this.files = this.selectedRoom.media;
    }
  },

  watch: {
    files(files) {
      this.addFilesToRoom([this.selectedRoom, files]);
    },
  },

  methods: {
    ...mapMutations({
      addFilesToRoom: 'room/addFilesToRoom',
      removeFileFromRoom: 'room/removeFileFromRoom',
    }),

    input() {
      this.$refs.upload.active = true; // Enable auto-upload
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = '';

      const URL = window.URL || window.webkitURL;

      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }

      return true;
    },
  },
};
</script>
